import React, { useState } from 'react';
import { Form, Button, Container, Card, Row, Col, Alert, Toast } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { addNews } from '../../services/newsService';

const NewsForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const [formData, setFormData] = useState({
    newsCategoryId: 'af000611-9cf6-e167-676b-46eb0606d4b9',
    date: '',
    header: '',
    detail: '',
    shortDetail: '',
    pictureUrl: '',
    picture: null,
    refererLink: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is an image
      if (!file.type.startsWith('image/')) {
        alert('Lütfen geçerli bir resim dosyası seçin');
        e.target.value = '';
        return;
      }
      // Check image size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Resim dosyası 5MB\'dan büyük olamaz');
        e.target.value = '';
        return;
      }

      setFormData(prevState => ({
        ...prevState,
        picture: file
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setShowToast(false);

    try {
      const response = await addNews(formData);
      if (response.isSuccess) {
        setToastMessage('Haber başarıyla eklendi!');
        setToastVariant('success');
        setShowToast(true);
        
        setTimeout(() => {
          navigate('/news');
        }, 1500);
      } else {
        const errorMessage = response.resultMessage || 'Haber eklenirken bir hata oluştu.';
        setError(errorMessage);
        setToastMessage(errorMessage);
        setToastVariant('danger');
        setShowToast(true);
      }
    } catch (error) {
      console.error('Error adding news:', error);
      const errorMessage = error.response?.data?.message || 'Haber eklenirken bir hata oluştu.';
      setError(errorMessage);
      setToastMessage(errorMessage);
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <div
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 9999
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={1500}
          autohide
          bg={toastVariant}
        >
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </div>

      <Card className="mt-4 mb-4">
        <Card.Body>
          <h2 className="mb-4">Yeni Haber Ekle</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Haber Başlığı</Form.Label>
              <Form.Control
                type="text"
                name="header"
                value={formData.header}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Haber Tarihi</Form.Label>
              <Form.Control
                type="datetime-local"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Detay</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="detail"
                value={formData.detail}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Haber Görseli</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Kısa Detay</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="shortDetail"
                value={formData.shortDetail}
                onChange={handleChange}
                placeholder="Kısa detay giriniz (opsiyonel)"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Referans Link</Form.Label>
              <Form.Control
                type="text"
                name="refererLink"
                value={formData.refererLink}
                onChange={handleChange}
                placeholder="Referans link giriniz"
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button 
                variant="secondary" 
                onClick={() => navigate('/news')}
                disabled={loading}
              >
                İptal
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
              >
                {loading ? 'Ekleniyor...' : 'Kaydet'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NewsForm;
